<div class="headerFlexW pr-4 m-3">
  <div class="content-block">
    <p class="bread-crumbs">Usuarios</p>
    <h2 class="">Usuarios</h2>
  </div>
</div>
<!-- CONTENT -->
<div class="content-block">

  <div class="dx-card">
      <dx-tab-panel #tabPanel
          [height]="'auto'"
          [dataSource]="tabs"
          [selectedIndex]="tabIndex"
          [loop]="false"
          [animationEnabled]="true"
          [swipeEnabled]="true"
          
          (onSelectionChanged)="onTabChange($event)">
        
          <!-- Tab Title-->
        <div *dxTemplate="let tab of 'title'">
          <span>{{tab.label}}</span>
        </div>
        
        <!-- Tab Content -->
        <div *dxTemplate="let tab of 'item'" class="responsive-paddings pt-0">
          <router-outlet></router-outlet>
        </div>

      </dx-tab-panel>
      
  </div>

</div>